import { Box } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles';
import { appEnv, getAppPlatform } from 'app/core/environment';
import Button from 'app/shared/components/button/Button';
import { CopyIconSvg } from 'app/shared/components/icon/icon-lib';
import { PadCollapse } from 'app/shared/components/misc';
import Body from 'app/shared/components/typography/body/Body';
import Heading from 'app/shared/components/typography/heading/Heading';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import styledConsts from 'app/styles/styledConsts';
import styledMixins from 'app/styles/styledMixins';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components/macro';

const EmailButton = styled(Button)`
  align-self: center;
  ${styledMixins.noRadiusRight}
`;

const CopyButton = styled(Button)`
  ${styledMixins.noRadiusLeft}
  padding-left: 5px;
  padding-right: 5px;
  border-left: 1px solid
    ${p => lighten(styledConsts.cPrimary(p), 0.3)};
  width: 55px;
  min-width: 55px;
`;

const emailAddress = 'support@iwarranty.co';

export default function Help(): JSX.Element {
  const { showSnack } = useShowInfo();

  const copyToClipboard = async () =>
    navigator.clipboard.writeText(emailAddress).then(() => {
      showSnack({
        message: 'Email copied to clipboard!',
      });
    });

  return (
    <>
      <PadCollapse pad={2} />
      <Heading color="primary">Hey there!</Heading>
      <PadCollapse pad={2} />
      <Body>Welcome aboard, trailblazer.</Body>
      <Body>
        This is an exciting time - and we want you to be a part of
        making iWarranty the best it can be!
      </Body>
      <Body>
        Over the coming months we will be expanding the scope of
        iWarranty, fixing any problems and adding more great features.
      </Body>
      <PadCollapse pad={2} />
      <Body color="primary" bold>
        Suggestions, questions, feedback or spotting bugs - all are
        welcome! Just drop us an email at
      </Body>
      <PadCollapse pad={2} />
      <Box display="flex" alignSelf="center">
        <EmailButton
          slim
          href={`mailto:${emailAddress}?subject=iWarranty ${_.capitalize(
            appEnv.APP_VARIANT
          )} App Feedback (platform: ${getAppPlatform()})`}
        >
          {/* NOTE: this is a hack to bypass the auto-capitalisation */}
          <>{emailAddress}</>
        </EmailButton>
        <CopyButton slim onClick={copyToClipboard}>
          <CopyIconSvg />
        </CopyButton>
      </Box>
    </>
  );
}
